import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useLanguage } from "contexts/language.context";
import MDButton from "components/MDButton";
import LoadingButton from "components/LoadingButton";

export default function BasicDialog({
  button,
  title,
  content,
  actions,
  cancelButton,
  open,
  setOpen,
  ...props
}) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const { label } = useLanguage();
  const handleClickOpen = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    setDialogOpen(open ? true : false);
  }, [open]);

  return (
    <>
      {button && <div onClick={handleClickOpen}>{button}</div>}
      <Dialog open={dialogOpen} onClose={handleClose} {...props}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {cancelButton && (
            <MDButton onClick={handleClose}>{label("cancel-button")}</MDButton>
          )}
          {actions?.map((action, index) => (
            <LoadingButton
              key={action.key || action.text || `dialog-action-${index}`}
              onClick={action.onClick}
              {...(action.props || {})}
            >
              {action.text}
            </LoadingButton>
          ))}
        </DialogActions>
      </Dialog>
    </>
  );
}
